// Helpers for resolving dot-paths against a tool's JSON-Schema
// configSchema. Draft-7 subset — only what the catalog components
// actually consume.
//
// Used by the Client. A duplicate of this file lives at
// Desktop/Common/ToolConfigSchema.js — KEEP IN SYNC.

const splitPath = (path) => {
  if (!path) return []
  return String(path).split('.').filter(Boolean)
}

export const resolveSchema = (schema, path) => {
  let cur = schema
  for (const key of splitPath(path)) {
    if (!cur || cur.type !== 'object' || !cur.properties) return undefined
    cur = cur.properties[key]
    if (!cur) return undefined
  }
  return cur
}

export const resolveParent = (schema, path) => {
  const parts = splitPath(path)
  if (parts.length === 0) return undefined
  const leafKey = parts[parts.length - 1]
  let cur = schema
  for (let i = 0; i < parts.length - 1; i++) {
    if (!cur || cur.type !== 'object' || !cur.properties) return undefined
    cur = cur.properties[parts[i]]
    if (!cur) return undefined
  }
  return { parent: cur, leafKey }
}

export const isRequired = (schema, path) => {
  const found = resolveParent(schema, path)
  if (!found) return false
  const { parent, leafKey } = found
  if (!parent || !Array.isArray(parent.required)) return false
  return parent.required.includes(leafKey)
}

export const getAtPath = (obj, path) => {
  let cur = obj
  for (const key of splitPath(path)) {
    if (cur == null) return undefined
    cur = cur[key]
  }
  return cur
}

export const setAtPath = (obj, path, value) => {
  const parts = splitPath(path)
  if (parts.length === 0) return obj
  const next = { ...(obj || {}) }
  let cur = next
  for (let i = 0; i < parts.length - 1; i++) {
    const k = parts[i]
    cur[k] = { ...(cur[k] || {}) }
    cur = cur[k]
  }
  cur[parts[parts.length - 1]] = value
  return next
}
